import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux'
import { persistStore } from 'redux-persist'
import { PersistGate } from 'redux-persist/integration/react'
import '../../css/app.scss';
import configureStore from './configureStore'
import appConfig from './appConfig'
// import Root from './Root'
import Drawer from '../drawer';
import containerValidator from './containerValidator'
import MyBookmakersPage from '../myBookmakersPage';

containerValidator();
appConfig()

const store = configureStore()
const persistor = persistStore(store)

/*
    Bind an API to the window object that returns the IDs
    of the current selections (and race) in the slip
 */
window.betslipApi = ({
    getSelectedBets: () => store.getState().bookmakersInfo.selectedBets.map(bet => ({
        raceId: bet.raceId,
        outcomersId: bet.outcomersId,
        meetingId: bet.meetingId,
    })),
    isHorseSelected: (raceId, outcomersId, meetingId) =>
        store.getState().bookmakersInfo.selectedBets.some(bet =>
            bet.raceId === raceId &&
            bet.outcomersId === outcomersId &&
            bet.meetingId === meetingId,
        ),
});

// // Render the Accounts button...
// render(
//     <Provider store={store}>
//         <PersistGate persistor={persistor}>
//             <Root />
//         </PersistGate>
//     </Provider>,
//     document.querySelector('#js-bs-bookmakersSwitcher'),
// );

// Render the drawer...
render(
    <Provider store={store}>
        <PersistGate persistor={persistor}>
            <Drawer />
        </PersistGate>
    </Provider>,
    document.querySelector('#js-bs-drawer'),
);

// Render the Bookmakers Page...
render(
    <Provider store={store}>
        <PersistGate persistor={persistor}>
            <MyBookmakersPage />
        </PersistGate>
    </Provider>
    ,
    document.querySelector('#js-bs-bookmakersPage'),
);



// WEBPACK FOOTER //
// /src/js/App/index.jsx